const customize = (state = { isProcessing: false }, action) => {
  switch (action.type) {
    case 'GET_GOALS':
      return {
        ...state,
        isProcessing: true,
      };
    case 'GET_GOALS_SUCCESS':
      return {
        ...state,
        isProcessing: false,
        goals: action.data,
      };
    case 'GET_GOALS_FAIL':
      return {
        ...state,
        error: action.error,
        isProcessing: false,
      };
    default:
      return state;
  }
};

export default customize;
